import "./landingPage.scss";
import { h } from "preact";
import { removeBackground, setupBackgound } from "./background";
import { AuthBox } from "./auth/auth";
import { type RoutableProps, route, } from "preact-router";
import { LinkButton } from "uitoolkit";
import { useCallback, useEffect, useState } from "preact/hooks";
import { useBodyStyle } from "hooks";
import { translate, useAnyTranslationsReady } from "services/translations";
import { isPWA } from "services/utils";

// tslint:disable: typedef
// tslint:disable: max-line-length

const stopPropagation = (event: Event) => { event.stopPropagation(); }

export const isAuthUrl = () => document.location.pathname.startsWith("/login") || document.location.pathname.startsWith("/forgotpassword") || document.location.pathname.startsWith("/signup") || document.location.pathname.startsWith("/resetpassword") || document.location.pathname.startsWith("/verifyemail");

export function LandingPage(props: RoutableProps) {
    const [isMenuVisible, setMenuVisible] = useState(isAuthUrl());
    useBodyStyle("landing");

    const hasTranslations = useAnyTranslationsReady();

    const hide = useCallback((ev: MouseEvent) => {
        if (ev && ev.button !== 0) return;
        if (document.location.pathname.startsWith("/signup")) return;
        setMenuVisible(false);
        route("/", true);
    }, []);

    const toggle = useCallback((event: Event) => {
        setMenuVisible(!isMenuVisible);
        if (!isMenuVisible) {
            const elem = document.getElementById("login");
            if (elem) {
                elem.focus();
            }
        }
    }, [isMenuVisible]);

    useEffect(() => {
        const onPopState = () => {
            setMenuVisible(isAuthUrl());
        };

        window.addEventListener("mousedown", hide);
        window.addEventListener("popstate", onPopState);
        setupBackgound();
        return () => {
            window.removeEventListener("mousedown", hide);
            window.removeEventListener("popstate", onPopState);
            removeBackground();
        };
    }, [hide]);

    return (
        <div>
            {
                hasTranslations &&
                <LinkButton class="authbtn" href="/login" onClick={toggle}>{translate("login_button_login")} &gt;</LinkButton>
            }
            <div className={"authbar " + (isMenuVisible ? "flyout--visible" : "")} onMouseDown={stopPropagation}>
                {/* {
                        state.isResettingPassword
                            ? <ForgotPasswordUi />
                            : <LoginUi onForgotPassword={this.onForgotPassword} />
                    } */}
                {
                    hasTranslations &&
                    <AuthBox />
                }
            </div>
            {
                //true && <HeroText />
            }
        </div>
    );
}

export function LandingPageSimple(props: RoutableProps) {
    const isSimple = true; // isPWA();
    const [isMenuVisible, setMenuVisible] = useState(isAuthUrl());
    useBodyStyle("landing", "pwa");

    const hasTranslations = useAnyTranslationsReady();

    useEffect(removeBackground, []);

    return (
        <div>
            <div className="authbar flyout--full">
                {
                    hasTranslations &&
                    <AuthBox />
                }
            </div>
        </div>
    );
}
